window.STUDENT_VERIFICATION_API_BASE_URL = "https://spf-middleware.justhazaar.com"; //https://stg-spf-middleware.justhazaar.com

(function () {
    var MODAL_SELECTOR = "[data-student-verification-test-modal]";
    var MODAL_OPEN_CLASS = "student-verification-test-modal-open";
    var RESUME_INTENT_KEY = "studentVerificationPending";
    var RESUME_CHECKOUT_KEY = "studentVerificationCheckoutUrl";
    var RESUME_MODE_KEY = "studentVerificationResumeMode";
    var RESUME_REDIRECT_READY_KEY = "studentVerificationResumeRedirectReady";
    var LAST_STOREFRONT_URL_KEY = "studentVerificationLastStorefrontUrl";
    var FIRST_PURCHASE_COMPLETED_KEY = "studentVerificationFirstPurchaseCompleted";
    var FIRST_PURCHASE_CHECKOUT_STARTED_KEY = "studentVerificationFirstPurchaseCheckoutStarted";
    var FIRST_PURCHASE_RETURN_REFRESH_KEY = "studentVerificationFirstPurchaseReturnRefresh";
    var RESEND_COOLDOWN_SECONDS = 30;
    var CHECKOUT_REDIRECT_DELAY_SECONDS = 3;
    var latestPurchaseState = null;
    var AUTO_PURCHASE_CLICK_SELECTOR = [
        'a[href="/checkout"]',
        'a[href$="/checkout"]',
        'button[name="checkout"]',
        'input[name="checkout"]',
        "[data-testid='Checkout-button']",
    ].join(", ");
    var AUTO_PURCHASE_FORM_SELECTOR = [
        'form[action$="/cart"]',
        'form[action*="/cart"]',
    ].join(", ");
    var PURCHASE_TRIGGER_SELECTOR = [
        ".js-student-verification-checkout",
        "[data-student-purchase-trigger]",
        AUTO_PURCHASE_CLICK_SELECTOR,
        AUTO_PURCHASE_FORM_SELECTOR,
    ].join(", ");
    var PURCHASE_GUARD_SELECTOR = [
        "[data-student-purchase-guard]",
        AUTO_PURCHASE_CLICK_SELECTOR,
        AUTO_PURCHASE_FORM_SELECTOR,
    ].join(", ");
    var AUTO_PURCHASE_SKIP_SELECTOR = [
        MODAL_SELECTOR,
        "[data-student-verification-test]",
        "#student-registration-modal",
        ".student-registration-wrap",
    ].join(", ");
    var EXPRESS_CHECKOUT_SELECTOR = [
        ".shopify-payment-button",
        ".shopify-payment-button__button",
        "[data-shopify='payment-button']",
        "shopify-accelerated-checkout",
        "shopify-accelerated-checkout-cart",
        "shopify-google-pay-button",
        ".cart__dynamic-checkout",
        ".additional-checkout-buttons",
        "#dynamic-checkout-cart",
    ].join(", ");

    function getApiBaseUrl() {
        return (window.STUDENT_VERIFICATION_API_BASE_URL || "").replace(/\/$/, "");
    }

    function apiUrl(path) {
        var baseUrl = getApiBaseUrl();
        return baseUrl ? baseUrl + path : path;
    }

    function isNgrokTunnelUrl(url) {
        try {
            var resolvedUrl = new URL(url, window.location.origin);
            return (
                /\.ngrok-free\.app$/i.test(resolvedUrl.hostname) ||
                /\.ngrok\.io$/i.test(resolvedUrl.hostname) ||
                /\.ngrok-free\.dev$/i.test(resolvedUrl.hostname)
            );
        } catch (error) {
            return false;
        }
    }

    function buildApiRequestHeaders(url, headers) {
        var requestHeaders = Object.assign({}, headers);

        if (isNgrokTunnelUrl(url)) {
            requestHeaders["ngrok-skip-browser-warning"] = "1";
        }

        return requestHeaders;
    }

    function getPrimaryVerificationRoot() {
        return (
            document.querySelector("[data-student-verification-test][data-student-login-url]") ||
            document.querySelector("[data-student-verification-test]")
        );
    }

    function getModalVerificationRoot() {
        return document.querySelector(MODAL_SELECTOR + " [data-student-verification-test]");
    }

    function getNavigationVerificationRoot() {
        return getModalVerificationRoot() || getPrimaryVerificationRoot();
    }

    function parseJsonSafely(text) {
        if (!text) {
            return null;
        }

        try {
            return JSON.parse(text);
        } catch (error) {
            return null;
        }
    }

    function getMessage(result, fallback) {
        if (!result || typeof result !== "object") {
            return fallback;
        }

        return result.message || result.error || result.details || fallback;
    }

    function normalizeEmail(email) {
        return (email || "").trim().toLowerCase();
    }

    function maskEmail(email) {
        var normalized = normalizeEmail(email);
        if (!normalized || normalized.indexOf("@") === -1) {
            return "";
        }

        var parts = normalized.split("@");
        var local = parts[0];
        var domain = parts[1];
        var domainParts = domain.split(".");
        var domainName = domainParts.shift() || "";
        var domainSuffix = domainParts.length ? "." + domainParts.join(".") : "";

        function maskPart(value) {
            if (!value) {
                return "";
            }
            if (value.length <= 2) {
                return value.charAt(0) + "*";
            }
            return value.charAt(0) + "*".repeat(Math.max(1, value.length - 2)) + value.charAt(value.length - 1);
        }

        return maskPart(local) + "@" + maskPart(domainName) + domainSuffix;
    }

    function validateEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    function validateOtp(otp) {
        return /^\d{6}$/.test(otp);
    }

    function isStudentUiElement(element) {
        return Boolean(element && element.closest(AUTO_PURCHASE_SKIP_SELECTOR));
    }

    function getCheckoutUrlFromElement(element) {
        if (!element) {
            return "/checkout";
        }

        if (element.hasAttribute("data-student-checkout-url")) {
            return element.getAttribute("data-student-checkout-url") || "/checkout";
        }

        if (element.tagName === "A") {
            return element.getAttribute("href") || "/checkout";
        }

        if (element.tagName === "FORM") {
            return "/checkout";
        }

        var form = element.form || element.closest("form");
        if (form) {
            return "/checkout";
        }

        return "/checkout";
    }

    function sanitizeStorefrontUrlString(value) {
        if (!value) {
            return "";
        }

        try {
            var url = new URL(value, window.location.origin);
            return getSanitizedStorefrontUrl(url);
        } catch (error) {
            return "";
        }
    }

    function sanitizeAuthUrl(value) {
        if (!value) {
            return "";
        }

        try {
            var url = new URL(value, window.location.origin);
            var nestedReturnTo = sanitizeStorefrontUrlString(url.searchParams.get("return_to"));
            var nestedReturnUrl = sanitizeStorefrontUrlString(url.searchParams.get("return_url"));

            url.searchParams.delete("sections");
            url.searchParams.delete("sections[]");
            url.searchParams.delete("section_id");

            if (nestedReturnTo) {
                url.searchParams.set("return_to", nestedReturnTo);
            } else {
                url.searchParams.delete("return_to");
            }

            if (nestedReturnUrl) {
                url.searchParams.set("return_url", nestedReturnUrl);
            }

            return url.toString();
        } catch (error) {
            return value;
        }
    }

    function getLoginUrlFromElement(element) {
        var navigationRoot = getNavigationVerificationRoot();
        if (navigationRoot) {
            var canonicalLoginUrl = navigationRoot.getAttribute("data-student-login-url") || "";
            if (canonicalLoginUrl) {
                return sanitizeAuthUrl(canonicalLoginUrl);
            }
        }

        if (!element) {
            var explicitRoot = getPrimaryVerificationRoot();
            return explicitRoot
                ? sanitizeAuthUrl(explicitRoot.getAttribute("data-student-login-url") || "")
                : "";
        }

        if (element.hasAttribute("data-student-login-url")) {
            return sanitizeAuthUrl(element.getAttribute("data-student-login-url") || "");
        }

        if (element.tagName === "A") {
            return sanitizeAuthUrl(element.getAttribute("href") || "");
        }

        var root = getPrimaryVerificationRoot();
        return root ? sanitizeAuthUrl(root.getAttribute("data-student-login-url") || "") : "";
    }

    function normalizeReturnUrl(value) {
        if (!value) {
            return "";
        }

        try {
            var url = new URL(value, window.location.origin);
            if (url.origin !== window.location.origin || isSectionRenderUrl(url)) {
                return "";
            }

            return buildRelativeUrl(url);
        } catch (error) {
            return "";
        }
    }

    function getReturnUrlFromElement(element) {
        var canonicalReturnUrl = buildResumeUrl();
        if (canonicalReturnUrl) {
            return canonicalReturnUrl;
        }

        if (!element) {
            var explicitRoot = getPrimaryVerificationRoot();
            return explicitRoot
                ? normalizeReturnUrl(explicitRoot.getAttribute("data-student-return-url") || "")
                : "";
        }

        if (element.hasAttribute("data-student-return-url")) {
            return normalizeReturnUrl(element.getAttribute("data-student-return-url") || "");
        }

        var root = getPrimaryVerificationRoot();
        return root ? normalizeReturnUrl(root.getAttribute("data-student-return-url") || "") : "";
    }

    function syncGuestCheckoutTargets() {
        var canonicalLoginUrl = getLoginUrlFromElement(null);
        var canonicalReturnUrl = buildResumeUrl();

        document.querySelectorAll("[data-student-purchase-trigger][data-student-purchase-kind='checkout']").forEach(function (element) {
            if (isStudentUiElement(element)) {
                return;
            }

            if (canonicalLoginUrl) {
                element.setAttribute("data-student-login-url", canonicalLoginUrl);
                if (element.tagName === "A") {
                    element.setAttribute("href", canonicalLoginUrl);
                }
            }

            if (canonicalReturnUrl) {
                element.setAttribute("data-student-return-url", canonicalReturnUrl);
            }
        });
    }

    function isSectionRenderUrl(url) {
        return Boolean(
            url &&
            (
                url.searchParams.has("sections") ||
                url.searchParams.has("sections[]") ||
                url.searchParams.has("section_id")
            )
        );
    }

    function getSanitizedStorefrontUrl(url) {
        if (!url) {
            return "/";
        }

        var nextUrl = new URL(url.toString());
        nextUrl.searchParams.delete("sections");
        nextUrl.searchParams.delete("sections[]");
        nextUrl.searchParams.delete("section_id");
        return buildRelativeUrl(nextUrl);
    }

    function buildRelativeUrl(url) {
        return url.pathname + url.search + url.hash;
    }

    function getLastStorefrontUrl() {
        try {
            return sessionStorage.getItem(LAST_STOREFRONT_URL_KEY) || "";
        } catch (error) {
            return "";
        }
    }

    function rememberStorefrontUrl(preferredUrl) {
        var currentUrl = preferredUrl
            ? new URL(preferredUrl, window.location.origin)
            : new URL(window.location.href);
        try {
            sessionStorage.setItem(LAST_STOREFRONT_URL_KEY, getSanitizedStorefrontUrl(currentUrl));
        } catch (error) {
        }
    }

    function buildResumeUrl() {
        var rememberedUrl = getLastStorefrontUrl();
        if (rememberedUrl) {
            return rememberedUrl;
        }

        var currentUrl = new URL(window.location.href);
        if (isSectionRenderUrl(currentUrl)) {
            return getSanitizedStorefrontUrl(currentUrl) || getLastStorefrontUrl() || "/";
        }

        return buildRelativeUrl(currentUrl);
    }

    function recoverFromSectionRenderUrl() {
        var currentUrl = new URL(window.location.href);
        if (!isSectionRenderUrl(currentUrl)) {
            return false;
        }

        var destination = getLastStorefrontUrl() || getSanitizedStorefrontUrl(currentUrl) || "/";
        if (!destination || destination === buildRelativeUrl(currentUrl)) {
            return false;
        }

        window.location.replace(destination);
        return true;
    }

    function setResumeIntent(checkoutUrl, mode) {
        try {
            sessionStorage.setItem(RESUME_INTENT_KEY, "1");
            sessionStorage.setItem(RESUME_CHECKOUT_KEY, checkoutUrl || "/checkout");
            if (mode) {
                sessionStorage.setItem(RESUME_MODE_KEY, mode);
            } else {
                sessionStorage.removeItem(RESUME_MODE_KEY);
            }
        } catch (error) {
        }
    }

    function hasResumeIntent() {
        try {
            return sessionStorage.getItem(RESUME_INTENT_KEY) === "1";
        } catch (error) {
            return false;
        }
    }

    function clearResumeIntent() {
        try {
            sessionStorage.removeItem(RESUME_INTENT_KEY);
            sessionStorage.removeItem(RESUME_CHECKOUT_KEY);
            sessionStorage.removeItem(RESUME_MODE_KEY);
            sessionStorage.removeItem(RESUME_REDIRECT_READY_KEY);
        } catch (error) {
        }
    }

    function clearResumeState() {
        clearResumeIntent();
    }

    function shouldResumeAfterLogin() {
        try {
            return hasResumeIntent() && sessionStorage.getItem(RESUME_MODE_KEY) === "login";
        } catch (error) {
            return false;
        }
    }

    function isVerificationResumePending() {
        try {
            return hasResumeIntent() && sessionStorage.getItem(RESUME_MODE_KEY) === "verify";
        } catch (error) {
            return false;
        }
    }

    function isResumeRedirectReady() {
        try {
            return sessionStorage.getItem(RESUME_REDIRECT_READY_KEY) === "1";
        } catch (error) {
            return false;
        }
    }

    function markResumeRedirectReady() {
        try {
            sessionStorage.setItem(RESUME_REDIRECT_READY_KEY, "1");
        } catch (error) {
        }
    }

    function clearResumeRedirectReady() {
        try {
            sessionStorage.removeItem(RESUME_REDIRECT_READY_KEY);
        } catch (error) {
        }
    }

    function getStoredCheckoutUrl() {
        try {
            return sessionStorage.getItem(RESUME_CHECKOUT_KEY) || "/checkout";
        } catch (error) {
            return "/checkout";
        }
    }

    function hasCompletedFirstPurchaseInSession() {
        var customerId = getCustomerIdFromDom();
        if (!customerId) {
            return false;
        }

        try {
            if (sessionStorage.getItem(FIRST_PURCHASE_COMPLETED_KEY) === customerId) {
                return true;
            }
        } catch (error) {
        }

        try {
            return localStorage.getItem(FIRST_PURCHASE_COMPLETED_KEY) === customerId;
        } catch (error) {
            return false;
        }
    }

    function markFirstPurchaseCompletedInSession() {
        var customerId = getCustomerIdFromDom();
        if (!customerId) {
            return;
        }

        try {
            sessionStorage.setItem(FIRST_PURCHASE_COMPLETED_KEY, customerId);
        } catch (error) {
        }

        try {
            localStorage.setItem(FIRST_PURCHASE_COMPLETED_KEY, customerId);
        } catch (error) {
        }
    }

    function hasStartedFirstPurchaseCheckoutInSession() {
        var customerId = getCustomerIdFromDom();
        if (!customerId) {
            return false;
        }

        try {
            if (sessionStorage.getItem(FIRST_PURCHASE_CHECKOUT_STARTED_KEY) === customerId) {
                return true;
            }
        } catch (error) {
        }

        try {
            return localStorage.getItem(FIRST_PURCHASE_CHECKOUT_STARTED_KEY) === customerId;
        } catch (error) {
            return false;
        }
    }

    function markFirstPurchaseCheckoutStartedInSession() {
        var customerId = getCustomerIdFromDom();
        if (!customerId) {
            return;
        }

        try {
            sessionStorage.setItem(FIRST_PURCHASE_CHECKOUT_STARTED_KEY, customerId);
        } catch (error) {
        }

        try {
            localStorage.setItem(FIRST_PURCHASE_CHECKOUT_STARTED_KEY, customerId);
        } catch (error) {
        }
    }

    function clearFirstPurchaseCompletedInSession() {
        try {
            sessionStorage.removeItem(FIRST_PURCHASE_COMPLETED_KEY);
        } catch (error) {
        }

        try {
            localStorage.removeItem(FIRST_PURCHASE_COMPLETED_KEY);
        } catch (error) {
        }
    }

    function clearFirstPurchaseCheckoutStartedInSession() {
        try {
            sessionStorage.removeItem(FIRST_PURCHASE_CHECKOUT_STARTED_KEY);
        } catch (error) {
        }

        try {
            localStorage.removeItem(FIRST_PURCHASE_CHECKOUT_STARTED_KEY);
        } catch (error) {
        }
    }

    function getFirstPurchaseReturnRefreshMarker() {
        try {
            return localStorage.getItem(FIRST_PURCHASE_RETURN_REFRESH_KEY) || "";
        } catch (error) {
            return "";
        }
    }

    function setFirstPurchaseReturnRefreshMarker(customerId) {
        if (!customerId) {
            return;
        }

        try {
            localStorage.setItem(FIRST_PURCHASE_RETURN_REFRESH_KEY, customerId);
        } catch (error) {
        }
    }

    function clearFirstPurchaseReturnRefreshMarker() {
        try {
            localStorage.removeItem(FIRST_PURCHASE_RETURN_REFRESH_KEY);
        } catch (error) {
        }
    }

    function clearCustomerScopedStorage(customerId) {
        var activeCustomerId = (customerId || "").trim();
        var sessionCompletedCustomerId = "";
        var sessionCheckoutStartedCustomerId = "";
        var localCompletedCustomerId = "";
        var localCheckoutStartedCustomerId = "";
        var localReturnRefreshCustomerId = "";

        try {
            sessionCompletedCustomerId = sessionStorage.getItem(FIRST_PURCHASE_COMPLETED_KEY) || "";
        } catch (error) {
        }

        try {
            sessionCheckoutStartedCustomerId = sessionStorage.getItem(FIRST_PURCHASE_CHECKOUT_STARTED_KEY) || "";
        } catch (error) {
        }

        try {
            localCompletedCustomerId = localStorage.getItem(FIRST_PURCHASE_COMPLETED_KEY) || "";
        } catch (error) {
        }

        try {
            localCheckoutStartedCustomerId = localStorage.getItem(FIRST_PURCHASE_CHECKOUT_STARTED_KEY) || "";
        } catch (error) {
        }

        try {
            localReturnRefreshCustomerId = localStorage.getItem(FIRST_PURCHASE_RETURN_REFRESH_KEY) || "";
        } catch (error) {
        }

        if (!activeCustomerId || (sessionCompletedCustomerId && sessionCompletedCustomerId !== activeCustomerId)) {
            try {
                sessionStorage.removeItem(FIRST_PURCHASE_COMPLETED_KEY);
            } catch (error) {
            }
        }

        if (!activeCustomerId || (sessionCheckoutStartedCustomerId && sessionCheckoutStartedCustomerId !== activeCustomerId)) {
            try {
                sessionStorage.removeItem(FIRST_PURCHASE_CHECKOUT_STARTED_KEY);
            } catch (error) {
            }
        }

        if (!activeCustomerId || (localCompletedCustomerId && localCompletedCustomerId !== activeCustomerId)) {
            try {
                localStorage.removeItem(FIRST_PURCHASE_COMPLETED_KEY);
            } catch (error) {
            }
        }

        if (!activeCustomerId || (localCheckoutStartedCustomerId && localCheckoutStartedCustomerId !== activeCustomerId)) {
            try {
                localStorage.removeItem(FIRST_PURCHASE_CHECKOUT_STARTED_KEY);
            } catch (error) {
            }
        }

        if (!activeCustomerId || (localReturnRefreshCustomerId && localReturnRefreshCustomerId !== activeCustomerId)) {
            try {
                localStorage.removeItem(FIRST_PURCHASE_RETURN_REFRESH_KEY);
            } catch (error) {
            }
        }
    }

    function maybeRefreshAfterFirstPurchaseCheckoutReturn() {
        var customerId = getCustomerIdFromDom();
        if (!customerId) {
            clearFirstPurchaseReturnRefreshMarker();
            return false;
        }

        if (hasCompletedFirstPurchaseInSession()) {
            clearFirstPurchaseCheckoutStartedInSession();
            clearFirstPurchaseReturnRefreshMarker();
            return false;
        }

        if (!hasStartedFirstPurchaseCheckoutInSession()) {
            clearFirstPurchaseReturnRefreshMarker();
            return false;
        }

        var purchaseState = getDomPurchaseState();
        if (!isFirstPurchaseEligibleState(purchaseState)) {
            clearFirstPurchaseReturnRefreshMarker();
            return false;
        }

        if (getFirstPurchaseReturnRefreshMarker() === customerId) {
            clearFirstPurchaseReturnRefreshMarker();
            clearFirstPurchaseCheckoutStartedInSession();
            return false;
        }

        setFirstPurchaseReturnRefreshMarker(customerId);
        window.location.reload();
        return true;
    }

    function referrerLooksLikeCheckoutCompletion() {
        if (!document.referrer) {
            return false;
        }

        try {
            var referrerUrl = new URL(document.referrer, window.location.origin);
            var referrerPath = referrerUrl.pathname || "";
            var referrerHref = referrerUrl.href || "";

            return (
                referrerPath.indexOf("/orders/") !== -1 ||
                referrerHref.indexOf("thank_you") !== -1 ||
                referrerHref.indexOf("order_status") !== -1
            );
        } catch (error) {
            return false;
        }
    }

    function syncFirstPurchaseCompletionState(statusResult) {
        var purchaseState = statusResult || getDomPurchaseState();
        var hasOrdersCount =
            purchaseState &&
            purchaseState.ordersCount !== undefined &&
            purchaseState.ordersCount !== null &&
            String(purchaseState.ordersCount).trim() !== "";
        var ordersCount = hasOrdersCount ? parseInt(purchaseState.ordersCount, 10) : null;
        var normalizedOrdersCount = ordersCount === null || Number.isNaN(ordersCount) ? null : ordersCount;

        if (referrerLooksLikeCheckoutCompletion() || normalizedOrdersCount > 0) {
            markFirstPurchaseCompletedInSession();
            clearFirstPurchaseCheckoutStartedInSession();
            return;
        }

        if (!hasCompletedFirstPurchaseInSession() && isFirstPurchaseEligibleState(purchaseState)) {
            clearFirstPurchaseCheckoutStartedInSession();
        }
    }

    function redirectToLogin(target, checkoutUrl) {
        var loginUrl = getLoginUrlFromElement(target);
        var returnUrl = getReturnUrlFromElement(target) || buildResumeUrl();
        if (!loginUrl) {
            return false;
        }

        rememberStorefrontUrl(returnUrl);
        clearResumeRedirectReady();
        setResumeIntent(checkoutUrl, "login");

        var destination = new URL(loginUrl, window.location.origin);
        destination.searchParams.set("return_url", returnUrl);
        window.location.href = destination.toString();
        return true;
    }

    function getCustomerIdFromDom() {
        var explicitNode = getPrimaryVerificationRoot();
        if (explicitNode) {
            var explicitCustomerId = (explicitNode.getAttribute("data-customer-id") || "").trim();
            if (explicitCustomerId) {
                return explicitCustomerId;
            }
        }

        var customerMeta = document.querySelector('meta[name="shopify-customer-id"]');
        if (customerMeta && customerMeta.content) {
            return "gid://shopify/Customer/" + customerMeta.content.trim();
        }

        if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) {
            var analyticsCustomerId = window.ShopifyAnalytics.meta.page && window.ShopifyAnalytics.meta.page.customerId;
            if (analyticsCustomerId) {
                return "gid://shopify/Customer/" + String(analyticsCustomerId).trim();
            }
        }

        return "";
    }

    function getInitialPurchaseState(root) {
        if (!root) {
            return {
                purchaseAllowed: false,
                status: "none",
                verified: false,
                studentEmail: "",
                verifiedAt: "",
                renewalDueAt: "",
                nonStudentConsentedAt: "",
                graceExpiresAt: "",
                ordersCount: 0,
                lifecycleState: "guest",
                checkoutDecision: "login",
            };
        }

        var purchaseAllowedRaw = (root.getAttribute("data-initial-purchase-allowed") || "").trim();
        var status = (root.getAttribute("data-initial-student-status") || "").trim() || "none";
        var verifiedRaw = (root.getAttribute("data-initial-student-verified") || "").trim();
        var studentEmail = normalizeEmail(root.getAttribute("data-initial-student-email") || "");
        var ordersCountRaw = (root.getAttribute("data-initial-customer-orders-count") || "").trim();
        var parsedOrdersCount = ordersCountRaw === "" ? null : parseInt(ordersCountRaw, 10);

        return {
            purchaseAllowed: purchaseAllowedRaw === "true",
            status: status,
            verified: verifiedRaw === "true",
            studentEmail: studentEmail,
            verifiedAt: (root.getAttribute("data-initial-student-verified-at") || "").trim(),
            renewalDueAt: (root.getAttribute("data-initial-student-renewal-due-at") || "").trim(),
            nonStudentConsentedAt: (root.getAttribute("data-initial-student-non-student-consented-at") || "").trim(),
            graceExpiresAt: (root.getAttribute("data-initial-student-grace-expires-at") || "").trim(),
            ordersCount: parsedOrdersCount === null || Number.isNaN(parsedOrdersCount) ? null : parsedOrdersCount,
            lifecycleState: (root.getAttribute("data-initial-lifecycle-state") || "").trim() || "guest",
            checkoutDecision: (root.getAttribute("data-initial-checkout-decision") || "").trim() || "",
        };
    }

    function resolveCheckoutDecision(statusResult) {
        if (!statusResult) {
            return "verify";
        }

        var lifecycleState = (statusResult.lifecycleState || "").trim();
        var explicitDecision = (statusResult.checkoutDecision || "").trim();
        var status = (statusResult.status || "none").trim();
        var hasOrdersCount =
            statusResult.ordersCount !== undefined &&
            statusResult.ordersCount !== null &&
            String(statusResult.ordersCount).trim() !== "";
        var ordersCount = hasOrdersCount ? parseInt(statusResult.ordersCount, 10) : null;
        var normalizedOrdersCount = ordersCount === null || Number.isNaN(ordersCount) ? null : ordersCount;

        if (explicitDecision && status !== "none") {
            return explicitDecision;
        }

        if (
            statusResult.purchaseAllowed ||
            status === "verified" ||
            status === "grace" ||
            statusResult.verified
        ) {
            return "checkout";
        }

        if (status === "expired") {
            return "blocked";
        }

        if (status === "pending_renewal") {
            return "verify";
        }

        if (
            hasCompletedFirstPurchaseInSession() &&
            (lifecycleState === "first_purchase" || (normalizedOrdersCount === 0 && status === "none"))
        ) {
            return "verify";
        }

        if (lifecycleState === "first_purchase") {
            return "checkout";
        }

        if (normalizedOrdersCount === 0 && status === "none") {
            return "checkout";
        }

        return "verify";
    }

    function shouldAllowCheckout(statusResult) {
        return resolveCheckoutDecision(statusResult) === "checkout";
    }

    function shouldOpenVerificationModal(statusResult) {
        var decision = resolveCheckoutDecision(statusResult);
        return decision === "verify" || decision === "blocked";
    }

    function shouldStoreResumeIntent(statusResult) {
        return resolveCheckoutDecision(statusResult) === "verify";
    }

    function getDomPurchaseState() {
        var modalRoot = document.querySelector(MODAL_SELECTOR + " [data-student-verification-test]");
        return getInitialPurchaseState(modalRoot || getPrimaryVerificationRoot());
    }

    function getCurrentPurchaseState() {
        return latestPurchaseState || getDomPurchaseState();
    }

    function shouldPreserveFirstPurchaseFallback(liveState, fallbackState) {
        var fallback = fallbackState && typeof fallbackState === "object" ? fallbackState : {};
        var live = liveState && typeof liveState === "object" ? liveState : {};

        return (
            !hasCompletedFirstPurchaseInSession() &&
            fallback.lifecycleState === "first_purchase" &&
            resolveCheckoutDecision(fallback) === "checkout" &&
            (live.status || "").trim() === "none" &&
            live.purchaseAllowed !== true &&
            live.verified !== true &&
            !live.lifecycleState &&
            !live.checkoutDecision &&
            (live.ordersCount === undefined || live.ordersCount === null || String(live.ordersCount).trim() === "")
        );
    }

    function isFirstPurchaseEligibleState(statusResult) {
        if (!statusResult) {
            return false;
        }

        var status = (statusResult.status || "").trim();
        var lifecycleState = (statusResult.lifecycleState || "").trim();
        var hasOrdersCount =
            statusResult.ordersCount !== undefined &&
            statusResult.ordersCount !== null &&
            String(statusResult.ordersCount).trim() !== "";
        var ordersCount = hasOrdersCount ? parseInt(statusResult.ordersCount, 10) : null;

        return (
            lifecycleState === "first_purchase" ||
            (status === "none" && ordersCount === 0)
        );
    }

    function mergeStatusWithFallback(statusResult, fallbackState) {
        var liveState = statusResult && typeof statusResult === "object" ? statusResult : {};
        var fallback = fallbackState && typeof fallbackState === "object" ? fallbackState : {};
        var mergedState = {};
        var key;
        var hasExplicitLiveStatus =
            liveState.status !== undefined &&
            liveState.status !== null &&
            String(liveState.status).trim() !== "";

        for (key in fallback) {
            if (Object.prototype.hasOwnProperty.call(fallback, key)) {
                mergedState[key] = fallback[key];
            }
        }

        for (key in liveState) {
            if (Object.prototype.hasOwnProperty.call(liveState, key)) {
                mergedState[key] = liveState[key];
            }
        }

        if (
            !hasExplicitLiveStatus &&
            (liveState.ordersCount === undefined || liveState.ordersCount === null || String(liveState.ordersCount).trim() === "") &&
            fallback.ordersCount !== undefined
        ) {
            mergedState.ordersCount = fallback.ordersCount;
        }

        if (!hasExplicitLiveStatus && !liveState.lifecycleState && fallback.lifecycleState) {
            mergedState.lifecycleState = fallback.lifecycleState;
        }

        if (!hasExplicitLiveStatus && !liveState.checkoutDecision && fallback.checkoutDecision) {
            mergedState.checkoutDecision = fallback.checkoutDecision;
        }

        if (hasExplicitLiveStatus) {
            mergedState.checkoutDecision = liveState.checkoutDecision || "";
            mergedState.lifecycleState = liveState.lifecycleState || "";

            if (
                liveState.ordersCount === undefined ||
                liveState.ordersCount === null ||
                String(liveState.ordersCount).trim() === ""
            ) {
                delete mergedState.ordersCount;
            }

            if (shouldPreserveFirstPurchaseFallback(liveState, fallback)) {
                mergedState.ordersCount = fallback.ordersCount;
                mergedState.lifecycleState = fallback.lifecycleState;
                mergedState.checkoutDecision = fallback.checkoutDecision || "checkout";
            }
        }

        return mergedState;
    }

    function requiresLiveStatusRefresh(statusResult) {
        if (!statusResult) {
            return false;
        }

        var decision = resolveCheckoutDecision(statusResult);
        var status = (statusResult.status || "none").trim();
        var lifecycleState = (statusResult.lifecycleState || "").trim();

        return decision === "checkout" && (status === "none" || lifecycleState === "first_purchase");
    }

    function syncExpressCheckoutVisibility(statusResult) {
        var purchaseAllowed = shouldAllowCheckout(statusResult || getCurrentPurchaseState());

        document.querySelectorAll(EXPRESS_CHECKOUT_SELECTOR).forEach(function (element) {
            if (!element.hasAttribute("data-student-original-display")) {
                element.setAttribute("data-student-original-display", element.style.display || "");
            }

            if (purchaseAllowed) {
                element.style.display = element.getAttribute("data-student-original-display") || "";
                element.removeAttribute("aria-hidden");
                return;
            }

            element.style.display = "none";
            element.setAttribute("aria-hidden", "true");
        });
    }

    function isExpressCheckoutElement(node) {
        return Boolean(node && node.closest && node.closest(EXPRESS_CHECKOUT_SELECTOR));
    }

    function redirectToCheckout(url) {
        window.location.href = url || "/checkout";
    }

    function continueToCheckout(target, purchaseKind, checkoutUrl) {
        if (purchaseKind === "submit") {
            var form = target.tagName === "FORM" ? target : target.form || target.closest("form");
            if (form) {
                if ((checkoutUrl || "").indexOf("/checkout") !== -1) {
                    redirectToCheckout(checkoutUrl);
                    return true;
                }

                if (!form.hasAttribute("data-student-bypass")) {
                    form.setAttribute("data-student-bypass", "true");
                }

                form.submit();
            }
            return true;
        }

        redirectToCheckout(checkoutUrl);
        return true;
    }

    function resumeCheckoutIfPending(statusResult, checkoutUrl) {
        if (
            !isVerificationResumePending() ||
            !isResumeRedirectReady() ||
            !shouldAllowCheckout(statusResult)
        ) {
            return false;
        }

        clearResumeState();
        redirectToCheckout(checkoutUrl || getStoredCheckoutUrl());
        return true;
    }

    function inferPurchaseKind(element) {
        if (!element) {
            return "checkout";
        }

        var explicitKind = (element.getAttribute("data-student-purchase-kind") || "").trim();
        if (explicitKind) {
            return explicitKind;
        }

        if (element.matches && element.matches(AUTO_PURCHASE_FORM_SELECTOR)) {
            return "submit";
        }

        return "checkout";
    }

    function getPurchaseTriggerFromNode(node) {
        if (!node || !node.closest) {
            return null;
        }

        if (isExpressCheckoutElement(node)) {
            return null;
        }

        var trigger = node.closest(PURCHASE_TRIGGER_SELECTOR);
        if (!trigger || isStudentUiElement(trigger)) {
            return null;
        }

        return trigger;
    }

    function formatDate(value) {
        if (!value) {
            return "";
        }

        var date = new Date(value);
        if (Number.isNaN(date.getTime())) {
            return value;
        }

        return date.toLocaleString(undefined, {
            year: "numeric",
            month: "short",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
        });
    }

    function setButtonLoading(button, isLoading) {
        if (!button) {
            return;
        }

        if (!button.dataset.defaultLabel) {
            button.dataset.defaultLabel = button.textContent;
        }

        button.disabled = isLoading;
        button.textContent = isLoading
            ? button.getAttribute("data-loading-label") || "Loading..."
            : button.dataset.defaultLabel;
    }

    function setButtonsLoading(buttons, isLoading) {
        buttons.forEach(function (button) {
            setButtonLoading(button, isLoading);
        });
    }

    function openModal(modal) {
        if (!modal) {
            return;
        }

        modal.hidden = false;
        document.body.classList.add(MODAL_OPEN_CLASS);
    }

    function closeModal(modal) {
        if (!modal) {
            return;
        }

        modal.hidden = true;
        document.body.classList.remove(MODAL_OPEN_CLASS);
    }

    function initModalFlow() {
        document.addEventListener("click", function (event) {
            var openTrigger = event.target.closest("[data-open-student-verification-test-modal]");
            if (openTrigger) {
                var targetSelector =
                    openTrigger.getAttribute("data-open-student-verification-test-modal") ||
                    MODAL_SELECTOR;
                var targetModal = document.querySelector(targetSelector);

                if (targetModal) {
                    event.preventDefault();
                    openModal(targetModal);
                }

                return;
            }

            var closeTrigger = event.target.closest("[data-close-student-verification-test-modal]");
            if (closeTrigger) {
                var modal = closeTrigger.closest(MODAL_SELECTOR);

                if (modal) {
                    event.preventDefault();
                    closeModal(modal);
                }
            }
        });

        document.addEventListener("keydown", function (event) {
            if (event.key !== "Escape") {
                return;
            }

            document.querySelectorAll(MODAL_SELECTOR).forEach(function (modal) {
                if (!modal.hidden) {
                    closeModal(modal);
                }
            });
        });
    }

    async function fetchStudentStatus(customerId) {
        var url = apiUrl("/api/student/status?customerId=" + encodeURIComponent(customerId));
        var response = await fetch(url, {
            method: "GET",
            headers: buildApiRequestHeaders(url),
        });
        var responseText = await response.text();
        var result = parseJsonSafely(responseText) || {};

        if (!response.ok) {
            throw new Error(getMessage(result, "Unable to fetch student status"));
        }

        return result;
    }

    async function fetchCustomerOrdersCount(customerId) {
        var url = apiUrl("/api/customer/orders-count?customerId=" + encodeURIComponent(customerId));
        var response = await fetch(url, {
            method: "GET",
            headers: buildApiRequestHeaders(url),
        });
        var responseText = await response.text();
        var result = parseJsonSafely(responseText) || {};

        if (!response.ok) {
            throw new Error(getMessage(result, "Unable to fetch customer orders count"));
        }

        return result;
    }

    async function fetchLatestPurchaseState(customerId, fallbackState) {
        var statusResult = await fetchStudentStatus(customerId);
        var mergedResult = mergeStatusWithFallback(statusResult, fallbackState);

        try {
            var ordersCountResult = await fetchCustomerOrdersCount(customerId);
            if (
                ordersCountResult &&
                ordersCountResult.ordersCount !== undefined &&
                ordersCountResult.ordersCount !== null &&
                String(ordersCountResult.ordersCount).trim() !== ""
            ) {
                mergedResult.ordersCount = parseInt(ordersCountResult.ordersCount, 10);
            }
        } catch (error) {
        }

        return mergedResult;
    }

    function applyPurchaseGuard(statusResult) {
        if (statusResult) {
            latestPurchaseState = mergeStatusWithFallback(statusResult, getCurrentPurchaseState());
        }

        var purchaseAllowed = shouldAllowCheckout(statusResult);

        syncExpressCheckoutVisibility(statusResult);

        document.querySelectorAll(PURCHASE_GUARD_SELECTOR).forEach(function (element) {
            if (isStudentUiElement(element)) {
                return;
            }

            if (purchaseAllowed) {
                if (element.dataset.studentOriginalDisabled === "true") {
                    element.setAttribute("disabled", "disabled");
                } else {
                    element.removeAttribute("disabled");
                }
                element.removeAttribute("aria-disabled");
                element.removeAttribute("data-student-locked");
                return;
            }

            element.setAttribute("aria-disabled", "true");
            element.setAttribute("data-student-locked", "true");
            if ("disabled" in element) {
                if (!element.hasAttribute("data-student-original-disabled")) {
                    element.dataset.studentOriginalDisabled = element.disabled ? "true" : "false";
                }
                if (element.dataset.studentOriginalDisabled === "true") {
                    element.disabled = true;
                } else {
                    element.disabled = false;
                }
            }
        });
    }

    async function refreshCurrentPurchaseState() {
        var customerId = getCustomerIdFromDom();
        var fallbackState = getDomPurchaseState();

        clearCustomerScopedStorage(customerId);

        if (!customerId) {
            latestPurchaseState = fallbackState;
            applyPurchaseGuard(fallbackState);
            return fallbackState;
        }

        try {
            var statusResult = await fetchLatestPurchaseState(customerId, fallbackState);
            syncFirstPurchaseCompletionState(statusResult);
            latestPurchaseState = statusResult;
            applyPurchaseGuard(statusResult);
            return statusResult;
        } catch (error) {
            syncFirstPurchaseCompletionState(fallbackState);
            latestPurchaseState = fallbackState;
            applyPurchaseGuard(fallbackState);
            return fallbackState;
        }
    }

    async function resolvePurchaseAttempt(target, eventType) {
        var customerId = (target.getAttribute("data-customer-id") || "").trim() || getCustomerIdFromDom();
        var checkoutUrl = getCheckoutUrlFromElement(target);
        var purchaseKind = inferPurchaseKind(target);
        var modal =
            document.querySelector(
                target.getAttribute("data-student-verification-modal-target") || MODAL_SELECTOR
            ) || document.querySelector(MODAL_SELECTOR);
        var modalRoot = modal ? modal.querySelector("[data-student-verification-test]") : null;
        var initialPurchaseState = mergeStatusWithFallback(getCurrentPurchaseState(), getInitialPurchaseState(modalRoot));

        if (!customerId) {
            if (redirectToLogin(target, checkoutUrl)) {
                return false;
            }

            return false;
        }

        target.setAttribute("data-customer-id", customerId);
        if (eventType === "click") {
            setButtonLoading(target, true);
        }

        var initialDecision = resolveCheckoutDecision(initialPurchaseState);
        if (initialDecision === "checkout" && !requiresLiveStatusRefresh(initialPurchaseState)) {
            if (isFirstPurchaseEligibleState(initialPurchaseState)) {
                markFirstPurchaseCheckoutStartedInSession();
            }
            applyPurchaseGuard(initialPurchaseState);
            return continueToCheckout(target, purchaseKind, checkoutUrl);
        }

        if (initialDecision === "blocked" && modal) {
            if (modalRoot) {
                modalRoot.setAttribute("data-customer-id", customerId);
                modalRoot.setAttribute("data-checkout-url", checkoutUrl);
                modalRoot.dispatchEvent(new CustomEvent("student:refresh-status"));
            }

            openModal(modal);
            return false;
        }

        try {
            var statusResult = await fetchLatestPurchaseState(customerId, initialPurchaseState);
            applyPurchaseGuard(statusResult);

            if (shouldAllowCheckout(statusResult)) {
                if (isFirstPurchaseEligibleState(statusResult)) {
                    markFirstPurchaseCheckoutStartedInSession();
                }
                return continueToCheckout(target, purchaseKind, checkoutUrl);
            }

            if (modal) {
                if (shouldStoreResumeIntent(statusResult)) {
                    clearResumeRedirectReady();
                    setResumeIntent(checkoutUrl, "verify");
                } else {
                    clearResumeState();
                }
                if (modalRoot) {
                    modalRoot.setAttribute("data-customer-id", customerId);
                    modalRoot.setAttribute("data-checkout-url", checkoutUrl);
                    modalRoot.dispatchEvent(new CustomEvent("student:refresh-status"));
                }

                openModal(modal);
            }
        } catch (error) {
            if (shouldAllowCheckout(initialPurchaseState)) {
                if (requiresLiveStatusRefresh(initialPurchaseState)) {
                    applyPurchaseGuard({
                        status: "none",
                        purchaseAllowed: false,
                        lifecycleState: "verification_required",
                        checkoutDecision: "verify",
                    });

                    if (modal) {
                        if (modalRoot) {
                            modalRoot.setAttribute("data-customer-id", customerId);
                            modalRoot.setAttribute("data-checkout-url", checkoutUrl);
                            modalRoot.dispatchEvent(new CustomEvent("student:refresh-status"));
                        }

                        openModal(modal);
                    }

                    return false;
                }

                applyPurchaseGuard(initialPurchaseState);
                return continueToCheckout(target, purchaseKind, checkoutUrl);
            }

            if (modal) {
                if (shouldStoreResumeIntent(initialPurchaseState)) {
                    clearResumeRedirectReady();
                    setResumeIntent(checkoutUrl, "verify");
                } else {
                    clearResumeState();
                }
                if (modalRoot) {
                    modalRoot.setAttribute("data-customer-id", customerId);
                    modalRoot.setAttribute("data-checkout-url", checkoutUrl);
                    modalRoot.dispatchEvent(new CustomEvent("student:refresh-status"));
                }

                openModal(modal);
            }
        } finally {
            if (eventType === "click") {
                setButtonLoading(target, false);
            }
        }

        return false;
    }

    function initCheckoutGate() {
        document.addEventListener("click", async function (event) {
            if (isExpressCheckoutElement(event.target)) {
                return;
            }

            var trigger = getPurchaseTriggerFromNode(event.target);
            if (!trigger) {
                return;
            }

            syncGuestCheckoutTargets();

            if (trigger.tagName === "A") {
                var sanitizedHref = sanitizeAuthUrl(trigger.getAttribute("href") || "");
                if (sanitizedHref) {
                    trigger.setAttribute("href", sanitizedHref);
                }
            }

            if (inferPurchaseKind(trigger) === "submit" && trigger.tagName === "FORM") {
                return;
            }

            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            await resolvePurchaseAttempt(trigger, "click");
        }, true);

        document.addEventListener("submit", async function (event) {
            if (event.submitter && event.submitter.name === "add") {
                return;
            }

            if (
                isExpressCheckoutElement(event.submitter) ||
                isExpressCheckoutElement(event.target)
            ) {
                return;
            }

            var trigger =
                (event.submitter && getPurchaseTriggerFromNode(event.submitter)) ||
                getPurchaseTriggerFromNode(event.target);
            if (!trigger) {
                return;
            }

            if (trigger.hasAttribute("data-student-bypass")) {
                trigger.removeAttribute("data-student-bypass");
                return;
            }

            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            await resolvePurchaseAttempt(trigger, "submit");
        });

        document.addEventListener("click", function (event) {
            if (isExpressCheckoutElement(event.target)) {
                return;
            }

            var lockedTarget = event.target.closest(PURCHASE_GUARD_SELECTOR + '[data-student-locked="true"]');
            if (!lockedTarget) {
                return;
            }

            if (isStudentUiElement(lockedTarget)) {
                return;
            }

            // Purchase triggers already run through resolvePurchaseAttempt, which fetches
            // live status before deciding whether checkout or verification should happen.
            if (lockedTarget.matches(PURCHASE_TRIGGER_SELECTOR)) {
                return;
            }

            var lockedCustomerId =
                (lockedTarget.getAttribute("data-customer-id") || "").trim() || getCustomerIdFromDom();
            if (!lockedCustomerId && getLoginUrlFromElement(lockedTarget)) {
                return;
            }

            event.preventDefault();

            var modal = document.querySelector(MODAL_SELECTOR);
            if (modal) {
                var lockedStatus = getInitialPurchaseState(
                    modal.querySelector("[data-student-verification-test]")
                );
                if (shouldStoreResumeIntent(lockedStatus)) {
                    clearResumeRedirectReady();
                    setResumeIntent(getCheckoutUrlFromElement(lockedTarget), "verify");
                } else {
                    clearResumeState();
                }
                var modalRoot = modal.querySelector("[data-student-verification-test]");
                if (modalRoot) {
                    modalRoot.setAttribute("data-customer-id", lockedCustomerId);
                    modalRoot.setAttribute("data-checkout-url", getCheckoutUrlFromElement(lockedTarget));
                    modalRoot.dispatchEvent(new CustomEvent("student:refresh-status"));
                }
                openModal(modal);
            }
        });
    }

    function initDynamicCheckoutObserver() {
        syncGuestCheckoutTargets();
        applyPurchaseGuard(getCurrentPurchaseState());

        var observer = new MutationObserver(function () {
            syncGuestCheckoutTargets();
            applyPurchaseGuard(getCurrentPurchaseState());
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }

    function initStudentVerificationTest(root) {
        var messageNode = root.querySelector("[data-message]");
        var customerNoteNode = root.querySelector("[data-customer-note]");
        var panelTitleNode = root.querySelector("[data-panel-title]");
        var panelSubtitleNode = root.querySelector("[data-panel-subtitle]");
        var emailLabelNode = root.querySelector("[data-email-label]");
        var otpHelperNode = root.querySelector("[data-otp-helper]");
        var statusBadgeNode = root.querySelector("[data-status-badge]");
        var statusTitleNode = root.querySelector("[data-status-title]");
        var statusCopyNode = root.querySelector("[data-status-copy]");
        var customerIdInput = root.querySelector('input[name="customerId"]');
        var emailWrap = root.querySelector("[data-email-wrap]");
        var otpWrap = root.querySelector("[data-otp-wrap]");
        var emailInput = root.querySelector('input[name="email"]');
        var otpInput = root.querySelector('input[name="otp"]');
        var sendInitialButton = root.querySelector("[data-send-initial]");
        var confirmInitialButton = root.querySelector("[data-confirm-initial]");
        var sendRenewButton = root.querySelector("[data-send-renew]");
        var confirmRenewButton = root.querySelector("[data-confirm-renew]");
        var consentButton = root.querySelector("[data-consent-non-student]");
        var resendButton = root.querySelector("[data-resend-otp]");
        var backButton = root.querySelector("[data-back]");
        var checkoutWrap = root.querySelector("[data-checkout-wrap]");
        var checkoutLink = root.querySelector("[data-checkout-link]");
        var allActionButtons = root.querySelectorAll(".student-verification-test__action");

        if (
            !messageNode ||
            !statusBadgeNode ||
            !statusTitleNode ||
            !statusCopyNode ||
            !customerIdInput ||
            !emailWrap ||
            !otpWrap ||
            !emailInput ||
            !otpInput ||
            !sendInitialButton ||
            !confirmInitialButton ||
            !sendRenewButton ||
            !confirmRenewButton ||
            !consentButton ||
            !resendButton ||
            !backButton ||
            !checkoutWrap ||
            !checkoutLink
        ) {
            return;
        }

        var state = {
            customerId: "",
            checkoutUrl: root.getAttribute("data-checkout-url") || "/checkout",
            status: "none",
            purchaseAllowed: false,
            lifecycleState: (root.getAttribute("data-initial-lifecycle-state") || "").trim() || "guest",
            checkoutDecision: (root.getAttribute("data-initial-checkout-decision") || "").trim() || "login",
            action: "none",
            statusPayload: null,
            initialStudentEmail: normalizeEmail(root.getAttribute("data-initial-student-email") || ""),
            otpMode: "",
            otpEmail: "",
            verifiedJustNow: false,
            resendCooldownTimer: null,
            resendRemainingSeconds: 0,
            checkoutRedirectTimer: null,
            checkoutRedirectRemainingSeconds: 0,
        };

        function setMetaValue(key, rawValue) {
            var item = root.querySelector('[data-meta-item="' + key + '"]');
            var valueNode = root.querySelector('[data-meta-value="' + key + '"]');
            if (!item || !valueNode) {
                return;
            }

            if (!rawValue) {
                item.hidden = true;
                valueNode.textContent = "";
                return;
            }

            item.hidden = false;
            valueNode.textContent =
                key === "verifiedAt" ||
                    key === "renewalDueAt" ||
                    key === "graceExpiresAt" ||
                    key === "nonStudentConsentedAt"
                    ? formatDate(rawValue)
                    : rawValue;
        }

        function hideAllActions() {
            allActionButtons.forEach(function (button) {
                button.hidden = true;
                button.disabled = false;
            });
        }

        function showMessage(type, text) {
            messageNode.className = "student-verification-test__message is-visible is-" + type;
            messageNode.textContent = text;
        }

        function clearMessage() {
            messageNode.className = "student-verification-test__message";
            messageNode.textContent = "";
        }

        function clearCheckoutRedirectCountdown() {
            if (state.checkoutRedirectTimer) {
                window.clearInterval(state.checkoutRedirectTimer);
                state.checkoutRedirectTimer = null;
            }
            state.checkoutRedirectRemainingSeconds = 0;
        }

        function updateCheckoutCta() {
            if (state.checkoutRedirectRemainingSeconds > 0) {
                checkoutLink.textContent =
                    "Taking you to checkout in " + state.checkoutRedirectRemainingSeconds + "...";
                return;
            }

            checkoutLink.textContent = "Time to checkout";
        }

        function startCheckoutRedirectCountdown() {
            if (
                !isVerificationResumePending() ||
                !isResumeRedirectReady() ||
                !shouldAllowCheckout({ status: state.status, purchaseAllowed: state.purchaseAllowed })
            ) {
                return false;
            }

            clearCheckoutRedirectCountdown();
            state.checkoutRedirectRemainingSeconds = CHECKOUT_REDIRECT_DELAY_SECONDS;
            showMessage(
                "success",
                "Verification complete. Taking you to checkout in " +
                state.checkoutRedirectRemainingSeconds +
                " seconds."
            );
            renderStatus();

            state.checkoutRedirectTimer = window.setInterval(function () {
                state.checkoutRedirectRemainingSeconds = Math.max(0, state.checkoutRedirectRemainingSeconds - 1);
                updateCheckoutCta();

                if (state.checkoutRedirectRemainingSeconds === 0) {
                    clearCheckoutRedirectCountdown();
                    clearResumeState();
                    redirectToCheckout(state.checkoutUrl || getStoredCheckoutUrl());
                }
            }, 1000);

            return true;
        }

        function completeCheckoutReadyState(successMessage, fallbackRefresh) {
            markResumeRedirectReady();
            state.verifiedJustNow = true;
            state.status = "verified";
            state.purchaseAllowed = true;
            state.otpMode = "";
            state.otpEmail = "";
            otpInput.value = "";
            clearResendCooldown();
            renderStatus();

            if (!startCheckoutRedirectCountdown()) {
                showMessage("success", successMessage);
                if (fallbackRefresh) {
                    fallbackRefresh();
                }
            }
        }

        function setStepState(stepName) {
            root.querySelectorAll("[data-step]").forEach(function (stepNode) {
                var currentStep = stepNode.getAttribute("data-step");
                var nextState = "next";

                if (currentStep === "signin") {
                    nextState = "done";
                } else if (stepName === "verify") {
                    nextState = currentStep === "verify" ? "active" : "next";
                } else if (stepName === "checkout") {
                    nextState =
                        currentStep === "verify" ? "done" : currentStep === "checkout" ? "active" : "done";
                }

                stepNode.setAttribute("data-step-state", nextState);
            });
        }

        function setCheckoutStepVisible(isVisible) {
            var checkoutStep = root.querySelector('[data-step="checkout"]');
            if (checkoutStep) {
                checkoutStep.hidden = !isVisible;
            }

            var connectors = root.querySelectorAll(".student-verification-test__connector");
            if (connectors.length > 1) {
                connectors[1].hidden = !isVisible;
            }
        }

        function setStepperVisible(isVisible) {
            var stepper = root.querySelector(".student-verification-test__steps");
            if (stepper) {
                stepper.hidden = !isVisible;
            }
        }

        function clearResendCooldown() {
            if (state.resendCooldownTimer) {
                window.clearInterval(state.resendCooldownTimer);
                state.resendCooldownTimer = null;
            }
            state.resendRemainingSeconds = 0;
        }

        function updateResendButtonLabel() {
            if (!resendButton) {
                return;
            }

            if (state.resendRemainingSeconds > 0) {
                resendButton.textContent = "Resend code in " + state.resendRemainingSeconds + "s";
                resendButton.disabled = true;
                resendButton.setAttribute("aria-disabled", "true");
                return;
            }

            resendButton.textContent = "Resend code";
            resendButton.disabled = false;
            resendButton.removeAttribute("aria-disabled");
        }

        function startResendCooldown(durationInSeconds) {
            clearResendCooldown();
            state.resendRemainingSeconds = durationInSeconds || RESEND_COOLDOWN_SECONDS;
            updateResendButtonLabel();

            state.resendCooldownTimer = window.setInterval(function () {
                state.resendRemainingSeconds = Math.max(0, state.resendRemainingSeconds - 1);
                updateResendButtonLabel();

                if (state.resendRemainingSeconds === 0) {
                    clearResendCooldown();
                    updateResendButtonLabel();
                }
            }, 1000);
        }

        function syncCustomerContext() {
            state.customerId = (root.getAttribute("data-customer-id") || "").trim();
            state.checkoutUrl = root.getAttribute("data-checkout-url") || "/checkout";
            customerIdInput.value = state.customerId;
            checkoutLink.setAttribute("href", state.checkoutUrl);
            updateCheckoutCta();

            if (customerNoteNode) {
                customerNoteNode.hidden = Boolean(state.customerId);
            }
        }

        function renderStatus() {
            var status = state.status || "none";
            var copy = "";
            var title = "Hazaar is an exclusive marketplace - by students, for students";
            var subtitle = "Verify you’re a student to unlock all the best deals  👀";
            var emailLabel = "Enter your student email:";
            var activeStep = "verify";
            var showCheckoutState = state.verifiedJustNow || state.checkoutDecision === "checkout";
            var renewalEmail = normalizeEmail(
                (state.statusPayload && state.statusPayload.studentEmail) || state.initialStudentEmail
            );
            var isRenewalState = status === "pending_renewal" || status === "expired";

            hideAllActions();
            emailWrap.hidden = true;
            otpWrap.hidden = true;
            checkoutWrap.hidden = !showCheckoutState;
            emailWrap.removeAttribute("data-otp-sent");
            emailInput.readOnly = false;
            setStepperVisible(true);
            setCheckoutStepVisible(true);

            if (!["none", "pending_renewal"].includes(status)) {
                state.otpMode = "";
                state.otpEmail = "";
                otpInput.value = "";
            }

            if (!showCheckoutState) {
                clearCheckoutRedirectCountdown();
            }

            statusBadgeNode.textContent = status.replace(/_/g, " ");

            if (status === "none") {
                statusTitleNode.textContent = "Student verification required";
                copy = "Verify your student email to unlock purchase access.";
                emailWrap.hidden = false;
                if (state.checkoutDecision === "checkout") {
                    statusTitleNode.textContent = "Ready for checkout";
                    copy = "Your first purchase can continue after sign in.";
                    title = "Continue to checkout";
                    subtitle = "Your account can continue directly to checkout.";
                    activeStep = "checkout";
                    emailWrap.hidden = true;
                } else if (state.otpMode === "initial") {
                    title = "We’ve sent an exclusive code to your email";
                    subtitle = " ";
                    emailWrap.hidden = false;
                    emailWrap.setAttribute("data-otp-sent", "true");
                    otpWrap.hidden = false;
                    confirmInitialButton.hidden = false;
                    resendButton.hidden = false;
                    backButton.hidden = false;
                    if (otpHelperNode) {
                        otpHelperNode.textContent =
                            "Code was sent to " + (state.otpEmail || "your student email") + ".";
                    }
                } else {
                    title = "Hazaar is an exclusive marketplace - by students, for students";
                    subtitle = "Verify you’re a student to unlock all the best deals  👀";
                    sendInitialButton.hidden = false;
                }
            } else if (status === "verified") {
                statusTitleNode.textContent = "Verified";
                copy = "Your student status is active and purchase is enabled.";
                title = "All done";
                subtitle = "You’re officially part of Hazaar - time to start saving";
                activeStep = "checkout";
            } else if (status === "pending_renewal") {
                statusTitleNode.textContent = "Renewal required";
                copy = "Renew your verification or submit non-student consent to continue.";
                emailWrap.hidden = false;
                consentButton.hidden = false;
                title = "Renew your student verification";
                subtitle = "Your yearly verification needs to be refreshed before checkout.";
                emailLabel = "Verification will be sent to your student email:";
                if (renewalEmail) {
                    emailInput.value = maskEmail(renewalEmail);
                    emailInput.readOnly = true;
                }
                if (state.otpMode === "renew") {
                    title = "Check your student inbox";
                    subtitle = "Enter the latest 6-digit code to renew access.";
                    emailWrap.hidden = false;
                    emailWrap.setAttribute("data-otp-sent", "true");
                    otpWrap.hidden = false;
                    confirmRenewButton.hidden = false;
                    resendButton.hidden = false;
                    backButton.hidden = false;
                    if (otpHelperNode) {
                        otpHelperNode.textContent =
                            "Use the 6-digit OTP sent to " + (state.otpEmail || "your student email") + ".";
                    }
                } else {
                    sendRenewButton.hidden = false;
                }
            } else if (status === "grace") {
                statusTitleNode.textContent = "Grace period active";
                copy = "Non-student consent is active. Purchase remains enabled until grace expiry.";
                title = "Checkout is available";
                subtitle = "Your access is active for now. Continue when ready.";
                activeStep = "checkout";
            } else if (status === "expired") {
                statusTitleNode.textContent = "Access expired";
                copy = "Your student access has expired and checkout is currently unavailable for this account.";
                title = "Student access expired";
                subtitle =
                    "This account can no longer continue through the student checkout flow. Close this window to keep browsing.";
                activeStep = "verify";
                setStepperVisible(false);
                setCheckoutStepVisible(false);
            } else {
                statusTitleNode.textContent = "Status unavailable";
                copy = "Unable to determine your student status right now.";
                title = "Student verification required";
                subtitle = "We could not load your verification status. Try again.";
            }

            if (showCheckoutState) {
                if (!(status === "none" && state.checkoutDecision === "checkout" && !state.verifiedJustNow)) {
                    title = "Verification complete";
                    subtitle = "Your account is verified. Continue to checkout.";
                }
                activeStep = "checkout";
                clearResendCooldown();
            }

            statusCopyNode.textContent = copy;
            if (panelTitleNode) {
                panelTitleNode.textContent = title;
            }
            if (panelSubtitleNode) {
                panelSubtitleNode.textContent = subtitle;
            }
            if (emailLabelNode) {
                emailLabelNode.textContent = emailLabel;
            }
            setStepState(activeStep);

            if (state.otpEmail && !isRenewalState && emailInput.value !== state.otpEmail) {
                emailInput.value = state.otpEmail;
            }
        }

        function applyStatusPayload(payload) {
            state.statusPayload = payload || null;
            state.status = (payload && payload.status) || "none";
            state.purchaseAllowed = shouldAllowCheckout(payload);
            state.lifecycleState = (payload && payload.lifecycleState) || state.lifecycleState;
            state.action = (payload && payload.action) || "none";
            state.checkoutDecision = resolveCheckoutDecision(payload);
            state.initialStudentEmail =
                normalizeEmail((payload && payload.studentEmail) || state.initialStudentEmail);
            if (state.purchaseAllowed || state.status === "verified" || state.status === "grace") {
                state.verifiedJustNow = false;
            }

            setMetaValue("studentEmail", payload && payload.studentEmail);
            setMetaValue("verifiedAt", payload && payload.verifiedAt);
            setMetaValue("renewalDueAt", payload && payload.renewalDueAt);
            setMetaValue("graceExpiresAt", payload && payload.graceExpiresAt);
            setMetaValue("nonStudentConsentedAt", payload && payload.nonStudentConsentedAt);

            applyPurchaseGuard(payload || { purchaseAllowed: false });
            renderStatus();
        }

        async function refreshStatus(showError) {
            syncCustomerContext();

            if (!state.customerId) {
                applyStatusPayload({
                    status: "none",
                    purchaseAllowed: false,
                    action: "blocked",
                    checkoutDecision: "login",
                });
                if (showError) {
                    showMessage("error", "Please sign in to continue student verification.");
                }
                return null;
            }

            try {
                var statusResult = await fetchLatestPurchaseState(
                    state.customerId,
                    getInitialPurchaseState(root)
                );
                syncFirstPurchaseCompletionState(statusResult);
                applyStatusPayload(statusResult);
                if (!startCheckoutRedirectCountdown()) {
                    resumeCheckoutIfPending(statusResult, state.checkoutUrl);
                }
                return statusResult;
            } catch (error) {
                syncFirstPurchaseCompletionState(getInitialPurchaseState(root));
                if (showError) {
                    showMessage("error", error.message || "Unable to fetch student status");
                }
                return null;
            }
        }

        async function callStudentApi(path, body, fallbackError) {
            var url = apiUrl(path);
            var response = await fetch(url, {
                method: "POST",
                headers: buildApiRequestHeaders(url, {
                    "Content-Type": "application/json",
                }),
                body: JSON.stringify(body),
            });
            var responseText = await response.text();
            var result = parseJsonSafely(responseText) || {};

            if (!response.ok) {
                var errorMessage = getMessage(result, fallbackError);

                if (response.status === 409) {
                    throw new Error(errorMessage);
                }

                if (response.status === 429) {
                    var retryAfter = response.headers.get("Retry-After");
                    if (retryAfter) {
                        throw new Error(errorMessage + " Retry after " + retryAfter + " seconds.");
                    }
                }

                throw new Error(errorMessage);
            }

            return result;
        }

        async function sendInitialOtp() {
            clearMessage();
            syncCustomerContext();

            var email = normalizeEmail(emailInput.value);
            emailInput.value = email;

            if (!state.customerId) {
                showMessage("error", "Customer session missing. Please log in and retry.");
                return;
            }

            if (!validateEmail(email)) {
                showMessage("error", "Enter a valid student email address.");
                emailInput.focus();
                return;
            }

            setButtonLoading(sendInitialButton, true);

            try {
                await callStudentApi(
                    "/api/student/verify/initial/send-otp",
                    { customerId: state.customerId, email: email },
                    "Unable to send initial verification code"
                );
                state.otpMode = "initial";
                state.otpEmail = email;
                await refreshStatus(false);
                startResendCooldown();
                renderStatus();
                showMessage("success", "Verification code sent.");
                otpInput.focus();
            } catch (error) {
                showMessage("error", error.message || "Unable to send initial verification code");
            } finally {
                setButtonLoading(sendInitialButton, false);
            }
        }

        async function confirmInitialOtp() {
            clearMessage();
            syncCustomerContext();

            var email = normalizeEmail(emailInput.value) || state.otpEmail;
            var otp = otpInput.value.trim();
            emailInput.value = email;

            if (!validateOtp(otp)) {
                showMessage("error", "Verification code must be exactly 6 digits.");
                otpInput.focus();
                return;
            }

            setButtonLoading(confirmInitialButton, true);

            try {
                await callStudentApi(
                    "/api/student/verify/initial/confirm-otp",
                    { customerId: state.customerId, email: email, otp: otp },
                    "Unable to confirm initial verification"
                );
                completeCheckoutReadyState("Initial verification completed.", function () {
                    refreshStatus(false);
                });
            } catch (error) {
                showMessage("error", error.message || "Unable to confirm initial verification");
            } finally {
                setButtonLoading(confirmInitialButton, false);
            }
        }

        async function sendRenewOtp() {
            clearMessage();
            syncCustomerContext();

            var email = normalizeEmail(
                (state.statusPayload && state.statusPayload.studentEmail) ||
                state.initialStudentEmail ||
                state.otpEmail
            );

            if (!validateEmail(email)) {
                showMessage("error", "No student email is available for renewal. Please contact support.");
                return;
            }

            setButtonLoading(sendRenewButton, true);

            try {
                await callStudentApi(
                    "/api/student/verify/renew/send-otp",
                    { customerId: state.customerId, email: email },
                    "Unable to send renewal verification code"
                );
                state.otpMode = "renew";
                state.otpEmail = email;
                await refreshStatus(false);
                startResendCooldown();
                renderStatus();
                showMessage("success", "Renewal verification code sent.");
                otpInput.focus();
            } catch (error) {
                showMessage("error", error.message || "Unable to send renewal verification code");
            } finally {
                setButtonLoading(sendRenewButton, false);
            }
        }

        async function confirmRenewOtp() {
            clearMessage();
            syncCustomerContext();

            var email = normalizeEmail(
                (state.statusPayload && state.statusPayload.studentEmail) ||
                state.initialStudentEmail ||
                state.otpEmail
            );
            var otp = otpInput.value.trim();

            if (!validateOtp(otp)) {
                showMessage("error", "Verification code must be exactly 6 digits.");
                otpInput.focus();
                return;
            }

            setButtonLoading(confirmRenewButton, true);

            try {
                await callStudentApi(
                    "/api/student/verify/renew/confirm-otp",
                    { customerId: state.customerId, email: email, otp: otp },
                    "Unable to confirm renewal verification"
                );
                completeCheckoutReadyState("Renewal verification completed.", function () {
                    refreshStatus(false);
                });
            } catch (error) {
                showMessage("error", error.message || "Unable to confirm renewal verification");
            } finally {
                setButtonLoading(confirmRenewButton, false);
            }
        }

        async function submitNonStudentConsent() {
            clearMessage();
            syncCustomerContext();
            setButtonLoading(consentButton, true);

            try {
                await callStudentApi(
                    "/api/student/consent/non-student",
                    { customerId: state.customerId, consent: true },
                    "Unable to submit non-student consent"
                );
                markResumeRedirectReady();
                state.otpMode = "";
                state.otpEmail = "";
                otpInput.value = "";
                state.verifiedJustNow = true;
                state.status = "grace";
                state.purchaseAllowed = true;
                clearResendCooldown();
                renderStatus();
                if (!startCheckoutRedirectCountdown()) {
                    showMessage("success", "Non-student consent submitted.");
                    refreshStatus(false);
                } else {
                    refreshStatus(false);
                }
            } catch (error) {
                showMessage("error", error.message || "Unable to submit non-student consent");
            } finally {
                setButtonLoading(consentButton, false);
            }
        }

        async function resendOtp() {
            if (state.otpMode === "initial") {
                await sendInitialOtp();
                return;
            }

            if (state.otpMode === "renew") {
                await sendRenewOtp();
                return;
            }

            showMessage("error", "No active OTP flow to resend.");
        }

        function resetOtpFlow() {
            state.otpMode = "";
            state.otpEmail = "";
            otpInput.value = "";
            clearResendCooldown();
            clearCheckoutRedirectCountdown();
            updateResendButtonLabel();
            updateCheckoutCta();
            clearMessage();
            renderStatus();
        }

        emailInput.addEventListener("input", function () {
            emailInput.value = normalizeEmail(emailInput.value);
        });

        otpInput.addEventListener("input", function () {
            otpInput.value = otpInput.value.replace(/\D/g, "").slice(0, 6);
        });

        sendInitialButton.addEventListener("click", sendInitialOtp);
        confirmInitialButton.addEventListener("click", confirmInitialOtp);
        sendRenewButton.addEventListener("click", sendRenewOtp);
        confirmRenewButton.addEventListener("click", confirmRenewOtp);
        consentButton.addEventListener("click", submitNonStudentConsent);
        resendButton.addEventListener("click", resendOtp);
        backButton.addEventListener("click", resetOtpFlow);

        root.addEventListener("student:refresh-status", function () {
            refreshStatus(false);
        });

        syncCustomerContext();
        applyStatusPayload(getInitialPurchaseState(root));
        updateResendButtonLabel();
        refreshStatus(false);
    }

    async function initPostLoginResume() {
        if (!shouldResumeAfterLogin()) {
            return;
        }

        var customerId = getCustomerIdFromDom();
        if (!customerId) {
            return;
        }

        var modal = document.querySelector(MODAL_SELECTOR);
        if (!modal) {
            clearResumeState();
            return;
        }

        var checkoutUrl = getStoredCheckoutUrl();

        var modalRoot = modal.querySelector("[data-student-verification-test]");
        if (modalRoot) {
            modalRoot.setAttribute("data-customer-id", customerId);
            modalRoot.setAttribute("data-checkout-url", checkoutUrl);
        }

        var initialPurchaseState = mergeStatusWithFallback(getCurrentPurchaseState(), getInitialPurchaseState(modalRoot));
        var initialDecision = resolveCheckoutDecision(initialPurchaseState);
        if (initialDecision === "checkout" && !requiresLiveStatusRefresh(initialPurchaseState)) {
            if (isFirstPurchaseEligibleState(initialPurchaseState)) {
                markFirstPurchaseCheckoutStartedInSession();
            }
            clearResumeState();
            redirectToCheckout(checkoutUrl);
            return;
        }

        try {
            var statusResult = await fetchLatestPurchaseState(customerId, initialPurchaseState);
            applyPurchaseGuard(statusResult);

            if (shouldAllowCheckout(statusResult)) {
                if (isFirstPurchaseEligibleState(statusResult)) {
                    markFirstPurchaseCheckoutStartedInSession();
                }
                clearResumeState();
                redirectToCheckout(checkoutUrl);
                return;
            }
            if (!shouldOpenVerificationModal(statusResult)) {
                clearResumeState();
                return;
            }
        } catch (error) {
            if (!shouldOpenVerificationModal(initialPurchaseState)) {
                clearResumeState();
                return;
            }
        }

        clearResumeRedirectReady();
        setResumeIntent(checkoutUrl, "verify");

        if (modalRoot) {
            modalRoot.dispatchEvent(new CustomEvent("student:refresh-status"));
        }

        openModal(modal);
    }

    document.addEventListener("DOMContentLoaded", async function () {
        if (recoverFromSectionRenderUrl()) {
            return;
        }
        clearCustomerScopedStorage(getCustomerIdFromDom());
        if (maybeRefreshAfterFirstPurchaseCheckoutReturn()) {
            return;
        }
        syncFirstPurchaseCompletionState();
        rememberStorefrontUrl();
        syncGuestCheckoutTargets();
        initModalFlow();
        initCheckoutGate();
        initDynamicCheckoutObserver();

        var roots = document.querySelectorAll("[data-student-verification-test]");
        roots.forEach(initStudentVerificationTest);
        await refreshCurrentPurchaseState();
        await initPostLoginResume();
    });

    window.addEventListener("pageshow", function () {
        clearCustomerScopedStorage(getCustomerIdFromDom());
        if (maybeRefreshAfterFirstPurchaseCheckoutReturn()) {
            return;
        }
        syncFirstPurchaseCompletionState();

        var navigationEntries = window.performance && window.performance.getEntriesByType
            ? window.performance.getEntriesByType("navigation")
            : [];
        var navigationType = navigationEntries.length ? navigationEntries[0].type : "";
        var domPurchaseState = getDomPurchaseState();

        if (navigationType === "back_forward" && domPurchaseState.lifecycleState === "first_purchase") {
            window.location.reload();
            return;
        }

        rememberStorefrontUrl();
        syncGuestCheckoutTargets();
        refreshCurrentPurchaseState();
    });
})();
